import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, FormControlLabel, Checkbox} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import {formatDate2} from "./date.js"
import { fetchHotelsname, addHotel, fetchDest } from "../api/customerapi";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";


const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Hoteldataentry = () => {

    const classes = useStyles();
    const { appData, loading } = useAppData();
    var { cuser, role } = GetRole();
 
    const [hotelData, sethotelData] =useState({
    hotel_name: "",
    hotel_area:"",
    hotel_destination: "",
    
    hotel_tripadvisor_link: "",
    city_center_area: "",
    
    hotel_usp: "",
    tag_onthebeach:false,
    tag_nearbeach:false,
    tag_bathtub:false,
    tag_mountainview:false,
    tag_riverfront:false,
    tag_oceanview:false,
    tag_cottage:false,
    tag_privatepool:false,
    });
    
    const [hData, sethData]=useState(null);
    const [dest, setdest]=useState([])
    const [cities, setcities]=useState([])

    const getHotels = async () => {
        try{
        const data = await fetchHotelsname();
        //const custdatalistfromdb= data.data
        sethData(data.data)
    }catch(err){
        console.log(err)
      }
    }

    const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      }

    const getCities = async () => {
        try{
        const data = await fetchDest();
        //console.log(data.data);
        const citylist= data.data.map(arr => arr.dest[0] == hotelData.hotel_destination ? [arr.cities] : [])
        const citylist2=citylist?.filter(arr => arr.length !==0 )
        const citylist3=citylist2[0]
       
      
        setcities(citylist3 ? [...citylist3[0]] :[])
    }catch(err){
        console.log(err)
      }
    }

    useEffect(() => {
        getHotels()
        getDest()
        
    }, [])

    useEffect(() => {
        
        getCities()
        
    }, [hotelData])

    //console.log(dest);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        let obj = hData.find(h=> h.hotel_name.trim() == hotelData.hotel_name.trim());
               
        if(obj){
            alert("Hotel name exists with hotel id "+obj.hotel_id) 
        }
        else{
        // const sortedhoteldatalistfromdb=hData.sort((a,b) => b.hotel_id - a.hotel_id);
        // const highesthotelid=sortedhoteldatalistfromdb[0].hotel_id;
        // const newhotelid = highesthotelid + 1;
        const finalhotelData= {...hotelData, createdAt:new Date(), updatedAt:new Date(), added_by:cuser};
        //console.log(finalhotelData);
        const addhotelResponse= await addHotel(finalhotelData);
        
        //console.log(finalhotelData);
        if(addhotelResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Please add hotel in costing sheet as well. New hotel added with hotel id "+addhotelResponse.data.hotel_id);
            //console.log(addhotelResponse)
            window.location = ("/hoteldataentry/"+addhotelResponse.data.hotel_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    
        
    } 
}catch(err){
    console.log(err)
  }
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Hotel</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  value={hotelData.hotel_name} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_name: e.target.value})}/>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Destination</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="primary destination" required value={hotelData.hotel_destination} onChange={(e)=> sethotelData({...hotelData, hotel_destination: e.target.value})}>
                    {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="city">City *</InputLabel>
                <Select displayEmpty classname={classes.textField} required labelId="city" value={hotelData.hotel_city} onChange={(e)=> sethotelData({...hotelData, hotel_city: e.target.value})}>
                    {cities?.map(city => {
                    return <MenuItem value={city}>{city}</MenuItem>})}
                    
                </Select>
                </FormControl>
                
                
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Hotel Area"  value={hotelData.hotel_area} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_area: e.target.value})}/>
                <TextField variant="standard"  label="City Center Area"  value={hotelData.city_center_area} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, city_center_area: e.target.value})}/>
                <TextField variant="standard" label="Distance from center(number in km)"   value={hotelData.distance_from_center} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, distance_from_center: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Star category">Star Category *</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Star category (number)" required value={hotelData.star_category} onChange={(e)=> sethotelData({...hotelData, star_category: e.target.value})}>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                </Select>
                </FormControl>
            
                <TextField variant="standard"  label="TripAdvisor Rating (number)"  value={hotelData.hotel_tripadvisor_rating} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_tripadvisor_rating: e.target.value})}/>
                <TextField variant="standard"  label="TripAdvisor Link"   value={hotelData.hotel_tripadvisor_link} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_tripadvisor_link: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Price Range">Price Range *</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Price Range" required value={hotelData.trip_owner} onChange={(e)=> sethotelData({...hotelData, hotel_price_range: e.target.value})}>
                    <MenuItem value={"Less than 1500"}>Less than 1500</MenuItem>
                    <MenuItem value={"1500-2500"}>1500-2500</MenuItem>
                    <MenuItem value={"2500-4000"}>2500-4000</MenuItem>
                    <MenuItem value={"4000-7000"}>4000-7000</MenuItem>
                    <MenuItem value={"7000-20000"}>7000-20000</MenuItem>
                    <MenuItem value={"More than 20000"}>More than 20000</MenuItem>
                </Select>
                </FormControl>
                <TextField variant="standard"  label="Rezlive Id" InputLabelProps={{ shrink: true }} value={hotelData.rezlive_id} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, rezlive_id: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_onthebeach} label="On the beach" onChange={(e)=> sethotelData({...hotelData, tag_onthebeach: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_nearbeach} label="Near beach" onChange={(e)=> sethotelData({...hotelData, tag_nearbeach: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_bathtub} label="Bathtub" onChange={(e)=> sethotelData({...hotelData, tag_bathtub: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_mountainview} label="Mountain View" onChange={(e)=> sethotelData({...hotelData, tag_mountainview: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_riverfront} label="Riverfront" onChange={(e)=> sethotelData({...hotelData, tag_riverfront: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_oceanview} label="Ocean View" onChange={(e)=> sethotelData({...hotelData, tag_oceanview: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_cottage} label="Cottage" onChange={(e)=> sethotelData({...hotelData, tag_cottage: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_privatepool} label="Private Pool" onChange={(e)=> sethotelData({...hotelData, tag_privatepool: e.target.checked})}/>
                </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Notes/USP"  value={hotelData.hotel_usp} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> sethotelData({...hotelData, hotel_usp: e.target.value})}/>
            </FormGroup>
            {/* Restriction so that user cannot use url to come to restricted page */}
            {role=="Admin" || role=="Manager" || role=="Product"?(
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
            ):("")}
            </form>
        </Paper>
     );
}

export default Hoteldataentry;